module.exports = __webpack_public_path__ + "static/img/Group 40365.86c268d1.svg";